import { TextBoxToolbarProps } from './Types'
import { track } from '@tldraw/tldraw'
import { Toolbar } from '../ContextToolbar/Toolbar'
import { CopyButton } from '../components/CopyButton/CopyButton'
import { DeleteButton } from '../components/DeleteButton/DeleteButton'
import { MoreOptionsButton } from '../components/MoreOptionsButton/MoreOptionsButton'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { MobileTextEditButton } from '../components/MobileTextEditButton/MobileTextEditButton'

const TextBoxToolbar = track(({ editor, shapeId }: TextBoxToolbarProps) => {
  const { isMobile } = useResponsiveDesign()
  const shape = editor.getShape(shapeId)

  return (
    <Toolbar>
      {isMobile && <MobileTextEditButton editor={editor} />}
      <CopyButton />
      <DeleteButton />
      <MoreOptionsButton selectedShape={shape} />
    </Toolbar>
  )
})

export { TextBoxToolbar }
